import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, Flame } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/beliefs", label: "Beliefs" },
  { to: "/sermons", label: "Sermons" },
  { to: "/events", label: "Events" },
  { to: "/ministries", label: "Ministries" },
  { to: "/prayer-centers", label: "Prayer Centers" },
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b hairline">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
            <span className="w-10 h-10 rounded-full border border-gold/70 flex items-center justify-center gold-glow">
              <Flame className="w-5 h-5 text-gold" />
            </span>
            <span className="hidden sm:flex flex-col leading-tight">
              <span className="font-display text-lg text-white tracking-tight">Assembly of Yahweh Shammah</span>
              <span className="font-accent text-[10px] text-zinc-400">Council</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                    isActive ? "text-gold" : "text-zinc-300 hover:text-white"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/give"
              data-testid="header-give-cta"
              className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gold text-black font-semibold text-sm hover:bg-slate-200 transition-colors duration-200"
            >
              Give
            </Link>
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t hairline bg-black/90">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md ${
                    isActive ? "text-gold bg-white/5" : "text-zinc-300"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/give"
              className="mt-2 text-center px-4 py-3 rounded-full bg-gold text-black font-semibold text-sm"
            >
              Give
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
